enum Ownership
{
	Owner = 1,
	CoOwner = 2,
	Tenant = 3,
	Subtenant = 4
}

export default Ownership;